import React from 'react';
import './styles/fonts.css';
import { GlobalStyle } from './styles/globalStyle';
import { Content } from './Content';
import { Navbar } from './components/br24/navbar/Navbar';
import { Footer } from './components/br24/footer/Footer';
import { mainConfig } from './config/config.provider';

export const App: React.FC = () => {
    return (
        <>
            <GlobalStyle />
            <Navbar showProgress={mainConfig.showProgress} />
            <Content />
            <Footer />
        </>
    );
};
